import { getDomainBranding } from '@saasalerts/ui'
import React from 'react'
import { useLicenseScope } from '@/contexts/LicenseScopeContext'

interface LogoProps {
  className?: string
  type?: 'light' | 'dark'
}

export const Logo: React.FC<LogoProps> = ({
  className = '',
  type = 'dark',
}) => {
  const licenseScope = useLicenseScope()
  const branding = getDomainBranding(licenseScope)!

  return (
    <img className={className} src={branding.logo[type]} alt={branding.name} />
  )
}
